var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49935 12C8.73002 12 9.86135 11.5767 10.764 10.8747L13.6947 13.8054L14.6373 12.8627L11.7067 9.93204C12.4093 9.02871 12.8327 7.89737 12.8327 6.66671C12.8327 3.72604 10.44 1.33337 7.49935 1.33337C4.55868 1.33337 2.16602 3.72604 2.16602 6.66671C2.16602 9.60738 4.55868 12 7.49935 12ZM7.49936 2.66671C9.70536 2.66671 11.4994 4.46071 11.4994 6.66671C11.4994 8.87271 9.70536 10.6667 7.49936 10.6667C5.29336 10.6667 3.49936 8.87271 3.49936 6.66671C3.49936 4.46071 5.29336 2.66671 7.49936 2.66671Z",
    fill: "#74788D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.44057 5.72406C8.69323 5.97739 8.83257 6.31206 8.83257 6.66672H10.1659C10.1659 5.95672 9.88857 5.28739 9.38323 4.78139C8.3739 3.77339 6.6239 3.77339 5.61523 4.78139L6.55657 5.72539C7.06323 5.22006 7.93657 5.22139 8.44057 5.72406Z",
    fill: "#74788D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.2701349cb655da70ff82464be5a9a094.svg";
export { ForwardRef as ReactComponent };